import {isString} from 'lodash';
import updateTierVisibility from './updateTierVisibility';
import addSources from './addSources';

function showLayers(map, tier, beforeLayerId) {
    updateTierVisibility(map, tier, beforeLayerId, tier.isVisible() ? 'visible' : 'none');
}

export default function addTier(map, tier, beforeLayerId) {
    const tierStyle = tier.getStyle();
    if (!tierStyle || isString(tierStyle)) {
        return;
    }

    addSources(map, tier);
    showLayers(map, tier, beforeLayerId);
}



// WEBPACK FOOTER //
// ./map/tier/styleUpdate/addTier.js